export let ActivityStatusType = /*#__PURE__*/function (ActivityStatusType) {
  ActivityStatusType["inTransit"] = "I";
  ActivityStatusType["delivered"] = "D";
  ActivityStatusType["exception"] = "X";
  ActivityStatusType["pickup"] = "P";
  ActivityStatusType["manifestPickup"] = "M";
  return ActivityStatusType;
}({});
export let ActivityStatusCode = /*#__PURE__*/function (ActivityStatusCode) {
  ActivityStatusCode["originScan"] = "OR";
  ActivityStatusCode["labelCreated"] = "MP";
  ActivityStatusCode["departedFromFacility"] = "DP";
  ActivityStatusCode["arrivedToFacility"] = "AR";
  ActivityStatusCode["processingAtFacility"] = "YP";
  return ActivityStatusCode;
}({});